export default {
  categories: {
    accessAccount: "Acceso y cuenta",
    myActivities: "Mis actividades",
    bookings: "Reservas",
    commissions: "Comisiones",
    onSitePayments: "Pagos in situ (restaurantes)",
    wallet: "Cartera",
    tablets: "Tablets y TPV",
    support: "Soporte",
  },
  items: {
    accessHow: {
      question: "¿Cómo obtengo acceso al portal?",
      answer: "Tras firmar el contrato, el soporte de Flitrip crea tu cuenta. Recibes un email en la dirección indicada en el contrato con un enlace para establecer la contraseña. Si el enlace ha caducado o el email no ha llegado, revisa spam y abre una solicitud de soporte.",
    },
    accessCredentials: {
      question: "¿Cómo cambio el email o la contraseña?",
      answer: "Abre un ticket de soporte: por ahora las credenciales no se pueden modificar desde el portal. Si cambia el personal que usa el portal, pide de inmediato el cambio de contraseña. El acceso es único y compartido, así que hasta que se cambie sigue siendo utilizable por quien lo tuvo antes.",
    },
    accessCollaborator: {
      question: "¿Puedo crear un acceso para un colaborador?",
      answer: "No, solo hay una cuenta. Puedes compartirla con quien trabaje contigo, teniendo en cuenta que las acciones en el portal no se pueden atribuir a una persona concreta.",
    },
    accessClose: {
      question: "¿Cómo cierro la relación con Flitrip?",
      answer: "Abre un ticket de soporte. Se aplican las condiciones de rescisión previstas en el contrato.",
    },
    accessApp: {
      question: "¿Hay una app que instalar?",
      answer: "No, Flitrip es una web app: se usa desde el navegador, también en el móvil. Si accedes a menudo desde el teléfono, añade el acceso directo a la pantalla de inicio. En iPhone: Compartir → Añadir a Inicio; en Android: menú del navegador → Añadir a pantalla de inicio. Desde ahí se abre como una app normal.",
    },
    activitiesAdd: {
      question: "¿Cómo añado una nueva actividad?",
      answer: "Las actividades las crea el soporte de Flitrip. Abre un ticket indicando nombre, descripción, duración, precio, aforo y fotos, y la publicamos por ti. Una vez online, la gestionas tú.",
    },
    activitiesEdit: {
      question: "¿Qué puedo modificar yo solo?",
      answer: "En una actividad publicada puedes cambiar precios, calendario y disponibilidad, fotos y descripción: los cambios se publican al instante sin pasar por soporte. Si cambias el precio, las reservas ya confirmadas mantienen lo pagado por el huésped: el cambio vale solo para las siguientes. Lo que no puedes hacer solo es crear o eliminar una actividad.",
    },
    activitiesDescription: {
      question: "¿Para qué sirve la descripción de mi actividad?",
      answer: "La descripción no es solo para leerla: es la fuente con la que el asistente de voz responde a las preguntas de los huéspedes. Si una información no está escrita ahí, el asistente no puede darla, y un huésped sin respuesta difícilmente reserva.",
    },
    activitiesLanguages: {
      question: "¿En qué idiomas se ven mis actividades?",
      answer: "Las descripciones se traducen automáticamente: no tienes que hacer nada. El huésped configura el tablet en su idioma y el asistente de voz le habla en ese idioma.",
    },
    activitiesAvailability: {
      question: "¿Cómo gestiono calendario y disponibilidad?",
      answer: "Desde Actividades → [nombre actividad] → Disponibilidad defines días y franjas reservables, número máximo de participantes y fechas cerradas por vacaciones o cierres. En días cerrados la actividad sigue visible pero no reservable, y reabres cuando quieras. Para cierres muy largos, abre un ticket de soporte.",
    },
    activitiesDelete: {
      question: "¿Cómo elimino una actividad?",
      answer: "La eliminación hay que solicitarla al soporte con un ticket. Si solo necesitas interrumpir reservas un periodo, cierra fechas en Disponibilidad: es inmediato y reversible.",
    },
    activitiesPhotos: {
      question: "¿Qué requisitos deben tener las fotos?",
      answer: "Se aceptan JPG y PNG. No hay límite de peso, pero para no ralentizar la carga en tablets conviene quedarse bajo 2 MB por imagen, con el lado largo alrededor de 2000 píxeles. La primera foto es la portada: es la que ve el huésped al explorar, así que elige la imagen más reconocible y usa formato horizontal. Evita logos, marcas de agua, texto superpuesto y collages. Si subes desde iPhone, las fotos están en HEIC, que no se acepta. Ve a Ajustes → Cámara → Formatos → Máxima compatibilidad, o convierte las fotos antes de subirlas.",
    },
    bookingsHandshake: {
      question: "¿Qué es el handshake y me conviene activarlo?",
      answer: "El handshake decide qué pasa cuando llega una reserva. Lo activas o desactivas en Ajustes → Perfil, y vale para todas tus actividades. Handshake activo: cada reserva llega como solicitud; puedes confirmarla, rechazarla o moverla, y escribir al huésped en chat. Te sirve si tienes plazas limitadas, quieres filtrar solicitudes o necesitas acordar horarios. Handshake desactivado: cada reserva se confirma sola. No tienes que vigilar nada, pero no puedes mover la reserva ni contactar al huésped: para cualquier necesidad debes pasar por soporte. Si dudas, sin handshake la única forma de liberarte de una reserva que no puedes atender es anularla.",
    },
    bookingsNotifications: {
      question: "¿Cómo recibo las notificaciones de reserva?",
      answer: "Por email o WhatsApp, a tu elección: configuras el canal en Ajustes → Perfil. Igual las encuentras todas en Reservas, que sigue siendo la referencia si se te escapa alguna notificación.",
    },
    bookingsNoConfirm: {
      question: "¿Qué pasa si no confirmo una reserva?",
      answer: "Solo con handshake activo. Tras 15 minutos sin respuesta recibes una llamada automática que lee los detalles: pulsa 1 en el teclado y la reserva se confirma al instante sin abrir el portal. La llamada viene de un número internacional +1: no es spam. Guárdalo en contactos. Si no respondes ni a la notificación ni a la llamada, tras 24 horas de inactividad la solicitud caduca y el huésped es reembolsado.",
    },
    bookingsLeadTime: {
      question: "¿Cuánto preaviso hace falta para reservar?",
      answer: "Lo configuras tú en el perfil: defines cuántas horas antes un huésped puede reservar. Calibra ese valor con el tiempo que realmente necesitas para prepararte. Los huéspedes reservan desde el tablet de la habitación, a menudo la misma noche para esa noche: un preaviso demasiado amplio te hace perder justo las reservas más frecuentes.",
    },
    bookingsCancel: {
      question: "¿Puedo anular una reserva confirmada?",
      answer: "Sí, abriendo la reserva en cualquier momento. El huésped es reembolsado al instante. Antes de anular, valora alternativas. Con handshake activo puedes mover la reserva o acordar en chat. Sin handshake, abre un ticket: soporte puede contactar al huésped y proponer otra fecha. Un huésped reubicado es mucho mejor que uno reembolsado.",
    },
    bookingsReschedule: {
      question: "¿Puedo mover una reserva o cambiar el número de personas?",
      answer: "Solo con handshake activo, abriendo la reserva. Sin handshake debes pasar por soporte, o anular.",
    },
    bookingsGuestId: {
      question: "¿Cómo reconozco al huésped cuando llega?",
      answer: "Por nombre y apellidos, que encuentras en Reservas. Al confirmar, el huésped recibe un PDF con todos los datos por WhatsApp o email, a su elección: si hay dudas, pídele que te lo muestre en el móvil.",
    },
    bookingsContactGuest: {
      question: "¿Cómo contacto a un huésped antes de la experiencia?",
      answer: "Con handshake activo, desde el chat dentro de la reserva. Sin handshake, contacta soporte con un ticket: no se te facilitan los datos directos del huésped.",
    },
    bookingsOverbooking: {
      question: "¿Riesgo de recibir más reservas de las que puedo gestionar?",
      answer: "No. El sistema se basa en la disponibilidad que tú defines: al alcanzar el número de plazas indicado para una franja, esa franja deja de ser reservable. Ten en cuenta que estos números son solo del canal Flitrip: no cuentan reservas por teléfono ni sin reserva. Configura la disponibilidad según el espacio que quieras reservar realmente a Flitrip.",
    },
    commissions: {
      question: "¿Cuáles son las comisiones?",
      answer: "La comisión aplicada es la establecida en el contrato firmado. Si tienes dudas sobre el cálculo de una comisión, contacta soporte.",
    },
    paymentsOnSite: {
      question: "¿Cómo me pagan?",
      answer: "El huésped paga directamente en el local, al terminar el servicio. Flitrip no cobra nada por ti y no hay saldo que esperar.",
    },
    paymentsReceiptWhy: {
      question: "¿Por qué debo subir el ticket?",
      answer: "El ticket nos permite calcular la comisión según el contrato. Sin ticket subido, la reserva no queda completada. Sube la foto abriendo la reserva al terminar el servicio: acostúmbrate a hacerlo antes de cerrar el día.",
    },
    paymentsReceiptHow: {
      question: "¿Qué fotografío exactamente?",
      answer: "El ticket o factura emitida al huésped por esa reserva, con importe y fecha legibles. Una foto bien hecha con el móvil basta.",
    },
    walletPayouts: {
      question: "¿Cuándo recibo los pagos?",
      answer: "Los pagos se realizan según plazos y términos del contrato: no tienes que solicitar retiro. En Cartera ves en todo momento el saldo y el historial de movimientos.",
    },
    walletReports: {
      question: "¿Cómo obtengo informes para mi gestor?",
      answer: "Solicítalos al soporte con un ticket, indicando el periodo que necesitas. En Cartera puedes consultar saldo y movimientos en cualquier momento.",
    },
    tabletsHow: {
      question: "¿Cómo funciona Flitrip en mi alojamiento?",
      answer: "Flitrip instala en las habitaciones un tablet con TPV asociado, mediante el cual tus huéspedes descubren y reservan experiencias, servicios y restaurantes de la zona, guiados por un asistente de voz en su idioma. Por cada reserva hecha desde los tablets de tu estructura recibes una comisión según el contrato. No vendes ni gestionas nada: tu tarea es que los dispositivos estén siempre listos.",
    },
    tabletsOwnership: {
      question: "¿Los dispositivos son míos?",
      answer: "No. Tablets y TPV los facilita Flitrip en comodato: siguen siendo propiedad de Flitrip y al terminar la relación los recogemos nosotros.",
    },
    tabletsDuty: {
      question: "¿De qué debo ocuparme?",
      answer: "De una sola cosa, pero importante: que los dispositivos estén cargados y listos, colocados de forma cómoda y visible para el huésped. Un tablet sin batería o guardado en un cajón no genera reservas ni comisiones.",
    },
    tabletsBroken: {
      question: "Un huésped dice que el tablet no funciona",
      answer: "Distingue dos casos. Si el pago no fue bien, el huésped puede reintentar en el tablet: no hace falta avisar. Si el dispositivo está averiado o no enciende, abre un ticket indicando la habitación. Nosotros sustituimos sin coste para ti.",
    },
    tabletsDamage: {
      question: "¿Si un huésped daña o se lleva un tablet?",
      answer: "Flitrip se hace cargo. No se te carga nada: solo pídenos que lo indiques con un ticket para restaurar el dispositivo.",
    },
    tabletsEarnings: {
      question: "¿Cómo veo cuánto estoy ganando?",
      answer: "En Reservas está el historial completo de reservas desde tus tablets y en Cartera el saldo acumulado con todos los movimientos. Los datos de huéspedes son confidenciales y solo para fines del servicio.",
    },
    tabletsGuestIssue: {
      question: "Un huésped tiene un problema con una reserva, ¿qué hago?",
      answer: "Invítale a seguir las indicaciones para contactar soporte Flitrip, en el tablet y en la confirmación de reserva. La gestión es enteramente nuestra: no tienes que resolverlo tú.",
    },
    tabletsOwnActivities: {
      question: "¿Puedo publicar también mis actividades?",
      answer: "Sí. En ese caso se añade un perfil de partner al de host y en el portal también gestionas actividades y reservas. Abre un ticket de soporte para activarlo.",
    },
    tabletsReturn: {
      question: "¿Qué pasa con los dispositivos si cierro la relación?",
      answer: "Recogemos nosotros tablets y TPV. No tienes que enviar nada ni organizar la devolución.",
    },
    supportTicket: {
      question: "¿Cómo abro un ticket?",
      answer: "Desde Ayuda y soporte → Enviar ticket. Sigue el estado en Mis tickets.",
    },
  },
} as const;
